import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ETLDataRecalculationObj } from './cxone-etl-data-recalculation.model';

@Injectable({
    providedIn: 'root'
})
export class CxoneEtlDataRecalculationService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async loadData(): Promise<ETLDataRecalculationObj[]> {
        try {
            const response = await this.cvApiService.get<ETLDataRecalculationObj[]>(`/api/v2/pipeline/recalculation-status`);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (error) {
            console.error(`Failed to load recalculations`);
            throw error;
        }
    }

}